export class Search {

	constructor( options ) {
		this.options = options
		this.button_search =  $( '.button-search' )
		this.search_form =  $( '.page-header-content .search-mobile' )
	}

	mobile_init() {
		const button_search = this.button_search
		const search_form = this.search_form
		const main_search = this

		button_search.click( function ( event ) {
			event.preventDefault()
			button_search.toggleClass( 'active' )
			search_form.toggle()

			if( typeof main_search.options.onButtonClick === 'function' ) {
				main_search.options.onButtonClick()
			}
		} )

		$(document).click( function( event ) {
			if( !$(event.target).closest( '.search-mobile, .button-search' ).length ) {
				if( $('.search-mobile').is(':visible') ) {
					$('.search-mobile').hide()
				}
			}
		})

	}

}


// WEBPACK FOOTER //
// ./scripts/components/search.js